import React from "react";

import ReactDataSheet from "react-datasheet";

const emptyRow = (pos) => [{ value: "" }, { value: "" }, { value: "" }, { value: "", readOnly: true }];

export default class Grilla extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            grid: this.generate(100),
        };
    }

    isNotEmpty = (row) => {
        if (row[0].value.length > 0) return true;

        return false;
    };

    generate(rows) {
        const colRows = new Array(rows).fill(null).map((_, i) => {
            return emptyRow(i);
        });

        return [...colRows];
    }

    _onCellsChanged = (changes) => {
        const grid = this.state.grid.map((row) => [...row]);
        changes.forEach(({ cell, row, col, value }) => {
            if (col === 2 && value !== "G") {
                return;
            } else {
                grid[row][col] = { ...grid[row][col], value };
            }
        });
        this.setState({ grid });
    };

    _reverseFormat = (listado) => {
        const grid = listado.map((row) => {
            return [{ value: row[0] }, { value: row[1] }, { value: row[2] }, { value: row[3], readOnly: true }];
        });

        return grid;
    };

    _onClick = () => {
        const completas = this.state.grid.filter(this.isNotEmpty);

        const form = completas.map((row) => {
            return [row[0].value, row[1].value, row[2].value];
        });

        this.props.handleSubmit(form);

        this.setState({
            grid: this._reverseFormat(form),
        });
    };

    _sheetRenderer = (props) => (
        <table className={props.className + " xable"} style={{ heigth: 300, width: "100%" }}>
            <thead>
                <tr>
                    <td style={{ width: 40 }}></td>
                    <td className="cell read-only" style={{ width: 120 }}>
                        Código
                    </td>
                    <td className="cell read-only">Litros</td>
                    <td className="cell read-only">Conector</td>
                    <td className="cell read-only">Resultado</td>
                </tr>
            </thead>
            <tbody>{props.children}</tbody>
        </table>
    );

    _rowRenderer = (props) => (
        <tr>
            <td className="cell read-only"></td>
            {props.children}
        </tr>
    );

    _valueRenderer = (cell) => cell.value;

    render() {
        return (
            <>
                <div className="box box-success">
                    <div className="box-header with-border">
                        <h3 className="box-title">
                            <i className="fa fa-pencil-square-o"></i> Se puede copiar y pegar desde Excel
                        </h3>
                    </div>
                    <div className="box-body">
                        <div className="row">
                            <div className="col-xs-12 col-sm-12 col-lg-12">
                                <button
                                    type="button"
                                    className="btn btn-flat btn-xs btn-primary"
                                    onClick={this._onClick}
                                >
                                    <i className="fa fa-floppy-o"></i> Cargar barriles
                                </button>
                            </div>
                        </div>
                        <br />
                        <div
                            className="table-responsive"
                            style={{ height: 600, overflowY: "scroll", paddingBottom: 30 }}
                        >
                            <ReactDataSheet
                                data={this.state.grid}
                                valueRenderer={this._valueRenderer}
                                onCellsChanged={this._onCellsChanged}
                                sheetRenderer={this._sheetRenderer}
                                rowRenderer={this._rowRenderer}
                            />
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
